import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import DynamicTabsDrawer from "../../../components/DynamicTabDrawer";
import NavigationDrawer from "../../../components/NavigationDrawer/index";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import AllPlans from "./AllPlans";
import Invoices from "./Invoices";
import { t } from "i18next";

function SupplierSubscription() {
  const dispatch = useDispatch();
  // Redux states
  const activeTab = useSelector((state) => state.activeTab.tabs);
  const userData = useSelector((state) => state.userData.user);

  console.log(userData, "AELLLLLLLLLO");

  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, subscription: tab }));
  };

  const tabs = [
    { label: "invoices", value: "invoice" },
    ...(userData?.isInternal === false
      ? [{ label: "allSubscriptions", value: "subscription" }]
      : []),
  ];

  return (
    <NavigationDrawer>
      <Grid container spacing={1}>
        <Grid item xs={12} md={2.3}>
          <DynamicTabsDrawer
            primaryHeading={t("plans")}
            tabs={tabs}
            activeTab={activeTab.subscription}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.7}>
          {activeTab.subscription === "invoice" ? <Invoices /> : <AllPlans />}
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
}

export default SupplierSubscription;
